import styles from './Account.module.scss';
import { Actions } from './components/Actions/Actions';
import { Subtitle } from './components/Subtitle/Subtitle';
import { Title } from './components/Title/Title';

type AccountProps = {
  email: string;
  name: {
    firstName: string;
    lastName: string;
  };
  handleContinueWithCurrentAccount: () => void;
  handleCreateNewAccount?: () => void;
};

export const AccountView = ({
  name,
  email,
  handleContinueWithCurrentAccount,
  handleCreateNewAccount,
}: AccountProps) => {
  return (
    <div className={styles.container}>
      <div className="p-body">
        <Title name={name} />
        <Subtitle email={email} />
        <Actions
          name={name}
          handleContinueWithCurrentAccount={handleContinueWithCurrentAccount}
          handleCreateNewAccount={handleCreateNewAccount}
        />
      </div>
    </div>
  );
};
